import React, {useContext} from "react";
import {CarecoApiContext} from "@/app-context/careco-api-context";
import {useAlertStore} from "@/store/alert_store";
import {useMutation} from "@tanstack/react-query";
import {ToastType} from "patient-ping-remedy/packages/toast";
import {AxiosError} from "axios";
import Helpers from "@/helpers/helpers";
import {SmallTypography} from "patient-ping-remedy/packages/typography";
import InfoIconTooltip from "@common/InfoIconTooltip";
import Button from "patient-ping-remedy/packages/button";
import {css} from "@emotion/css";
import Spacer from "patient-ping-remedy/packages/spacer";
import {sizes} from "patient-ping-remedy/packages/theme";

const UserPermissionsUpdate = () => {
  const { carecoApi } = useContext(CarecoApiContext);
  const { addAlert } = useAlertStore();

  const { mutate, isPending } = useMutation({
    mutationFn: async () =>
      carecoApi?.migrateUserPermissions(),
    onSuccess() {
      addAlert({
        content: 'User permissions are updated successfully into new data model.',
        type: ToastType.SUCCESS,
      });
    },
    onError(error: AxiosError) {
      Helpers.alertOnError( `Failed to update user permissions into new data model. ${Helpers.traceId(error)}`, error);
    },
  });

  return (
    <>
      <div>
        <SmallTypography>To update existing user permissions into new data model table, click button below</SmallTypography>
        <Spacer itemWidth={sizes.xSmall}/>
        <InfoIconTooltip
          text={'This will migrate all existing user permissions into new data model tables.'}
        />
      </div>
      <Button
        className={css({ marginTop: '30px' })}
        disabled={isPending}
        onClick={() => mutate()}
      >
        Update
      </Button>
    </>
  );
};

export default UserPermissionsUpdate;
